import { useTranslation } from "react-i18next";
import Bredcrumb from '../HomeMain/Bredcrumb'
import Appointment from '../HomeMain/Appointment'
import Testimonial from '../HomeMain/Testimonial'
import Service from '../HomeMain/Service'

const Main = () => {
  const { t } = useTranslation();

  return (
    <>
      <Bredcrumb title={t('pages.services.title')} subtitle={t('pages.services.subtitle')} />
      <div className="service-main-block">
        <Service />
      </div>
      <Appointment />
      <div className="testimonial-block">
        <Testimonial />
      </div>
    </>
  )
}

export default Main
